import * as React from 'react';
import { useLocation } from 'react-router';

/**
 * Resets scroll to the top whenever the route changes.
 *
 * We compare against the previously-rendered pathname (via a ref) rather than
 * scrolling on every mount, so that a hot-reload / Fast Refresh remount — which
 * re-runs effects without an actual navigation — doesn't yank the page back to
 * the top. Only a genuine pathname change scrolls.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = React.useRef(pathname);
  React.useEffect(() => {
    if (prevPathname.current !== pathname) {
      window.scrollTo(0, 0);
      prevPathname.current = pathname;
    }
  }, [pathname]);
  return null;
}
